(function () {
  const MULTI_COLUMN_SELECTOR = '.multi-column';
  const ITEM_SELECTOR = '.multi-column__item[reveal-on-scroll="true"]';
  const ANIMATION_DURATION = 450;
  const ANIMATION_DELAY = 100;
  const INITIAL_DELAY = 200;
  const OBSERVER_OPTIONS = { threshold: 0.25 };

  const motionSafe = () => window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  const supportsAnimation = (element) => typeof element?.animate === 'function';

  const clearRevealAttributes = (items) => {
    items.forEach((item) => {
      item.style.opacity = '';
      item.style.transform = '';
      item.removeAttribute('reveal-on-scroll');
    });
  };

  // 🔥 Left-to-right fade-in with staggered delay
  const animateItems = (items) => {
    items.forEach((item, index) => {
      item.animate(
        {
          opacity: [0, 1],
          transform: ['translateX(-40px)', 'translateX(0)']
        },
        {
          duration: ANIMATION_DURATION,
          delay: INITIAL_DELAY + index * ANIMATION_DELAY, // small delay between each item
          easing: 'ease-out',
          fill: 'forwards'
        }
      );
      item.removeAttribute('reveal-on-scroll');
    });
  };

  const revealSection = (container, observer) => {
    const items = container.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) return;

    if (!motionSafe() || !supportsAnimation(items[0])) {
      // If animations are not supported or user prefers reduced motion,
      // just show items normally.
      clearRevealAttributes(items);
      if (observer) observer.disconnect();
      return;
    }

    animateItems(items);
    if (observer) observer.disconnect();
  };

  const bindContainer = (container) => {
    if (!container || container.dataset.multiColumnRevealBound === 'true') {
      return;
    }

    container.dataset.multiColumnRevealBound = 'true';

    const items = container.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) return;

    // ⏳ Initial state: hidden & shifted left (only if motion is allowed)
    if (motionSafe() && supportsAnimation(items[0])) {
      items.forEach((item) => {
        item.style.opacity = '0';
        item.style.transform = 'translateX(-40px)';
      });
    } else {
      // If no motion: just clear attributes so they appear
      clearRevealAttributes(items);
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealSection(container, obs);
        }
      });
    }, OBSERVER_OPTIONS);

    observer.observe(container);
  };

  const scanAndBind = (root = document) => {
    root.querySelectorAll(MULTI_COLUMN_SELECTOR).forEach(bindContainer);
  };

  document.addEventListener('shopify:section:load', (event) => {
    scanAndBind(event.target);
  });

  scanAndBind();
})();
